import {defineMessages} from 'react-intl';

/**
 * The definition of messages to be used in the component and available in
 * supported translations. If translation is not available the default message
 * is used.
 */
const messages = defineMessages({
  VENUE: {
    id: 'jumbotron.banner.heading.venue',
    defaultMessage: 'Events at {heading}',
  },
  GEOGRAPHY: {
    id: 'jumbotron.banner.heading.geography',
    defaultMessage: 'Events in {heading}',
  },
});

export default messages;
